import React, { useState, useEffect, useCallback } from 'react';
import { Container, Typography, Card, CardContent, Box, Button, CircularProgress, Grid, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Line } from 'react-chartjs-2';
import { api } from '../api';

const TrendsPage = ({ initialTrendsData }) => {
    const [trendsData, setTrendsData] = useState(initialTrendsData);
    const [loading, setLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);

    const fetchTrends = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get(`/trends`);
            setTrendsData(response.data);
        } catch (err) {
            console.error("Failed to fetch trends data", err);
            setTrendsData({ interestOverTime: { labels: [], datasets: [] }, relatedKeywords: [] });
            alert("Could not fetch new trends data. The service may be temporarily unavailable.");
        } finally {
            setLoading(false);
            setHasFetched(true);
        }
    }, []);

    useEffect(() => {
        if (!initialTrendsData || !initialTrendsData.interestOverTime?.labels?.length) {
            if (!hasFetched) {
               fetchTrends();
            }
        } else {
            setHasFetched(true);
        }
    }, [fetchTrends, initialTrendsData, hasFetched]);
    
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: { y: { beginAtZero: true, title: { display: true, text: 'Search Interest' } } }
    };

    const safeInterestData = trendsData?.interestOverTime || { labels: [], datasets: [] };
    const safeRelatedKeywords = trendsData?.relatedKeywords || [];

    return (
        <Container maxWidth="lg">
            <Typography variant="h4" gutterBottom>Trend Analysis</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <Card>
                        <CardContent sx={{ height: '70vh' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6">Google Trends: JazzCash vs. Easypaisa</Typography>
                                <Button variant="outlined" onClick={fetchTrends} disabled={loading}>
                                    {loading ? <CircularProgress size={24} sx={{ mr: 1 }} /> : <RefreshIcon sx={{ mr: 1 }} />}
                                    {loading ? 'Refreshing...' : 'Refresh'}
                                </Button>
                            </Box>
                            <Box sx={{ height: 'calc(100% - 40px)', position: 'relative' }}>
                                {loading ? (
                                     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><CircularProgress /></Box>
                                ) : (
                                    <Line data={safeInterestData} options={chartOptions} />
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                     <Card>
                        <CardContent sx={{ height: '70vh' }}>
                             <Typography variant="h6" gutterBottom>Related Keywords</Typography>
                             <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{fontWeight: 'bold'}}>Query</TableCell>
                                            <TableCell sx={{fontWeight: 'bold'}}>Value</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {safeRelatedKeywords.map((kw, i) => (
                                            <TableRow key={i}>
                                                <TableCell>{kw.query}</TableCell>
                                                <TableCell>{kw.value}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default TrendsPage;